export default function eCardManageIndex(){
    return (
        <div>
            电子卡管理
        </div>
    )
};